'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Context = require('./Context.cjs');

/**
 * @deprecated You probably want to use `createUmi` from
 * `@metaplex-foundation/umi-bundle-defaults` instead. If
 * you're sure you want to use the base Umi without any plugins,
 * you can use `createBaseUmi` instead.
 *
 * @example Using defaults bundle:
 * import { createUmi } from '@metaplex-foundation/umi-bundle-defaults';
 * const umi = createUmi('https://...');
 *
 * @example Base only (no plugins):
 * import { createBaseUmi } from '@metaplex-foundation/umi';
 * const umi = createBaseUmi();
 */
const createUmi = () => createBaseUmi();

/**
 * Creates a Umi instance using only Null implementations of the interfaces.
 * The `use` method can then be used to install plugins and replace the
 * Null implementations with real implementations.
 *
 * @category Context and Interfaces
 */
const createBaseUmi = () => ({
  ...Context.createNullContext(),
  use(plugin) {
    plugin.install(this);
    return this;
  }
});

exports.createBaseUmi = createBaseUmi;
exports.createUmi = createUmi;
//# sourceMappingURL=Umi.cjs.map
